import React from "react"

function Header() {
    return(
        <header className="bg-3 h-24 flex justify-center items-center">
            <h1 className="rm-text4 text-5xl tracking-widest">MEMORY GAME</h1>
        </header>
    )
}
export default Header